module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Mask-60b652ab23bddf47902f4f5346ec6e42.svg";